import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PartnerApiKey, PartnerApiKeyType} from "../../../../dto/partner-api-key";
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-add-apikey-dialog',
  templateUrl: './add-apikey-dialog.component.html',
  styleUrls: ['./add-apikey-dialog.component.css']
})
export class AddApikeyDialogComponent implements OnInit {

  public static PermissionCreditCardPayment = 'creditcard_payment';
  public static PermissionInvoicePayment = 'invoice_payment';
  public static PermissionSofortPayment = 'sofort_payment';
  public static PermissionPartnerPayment = 'partner_payment';
  public static PermissionWalletBalance = 'wallet_balance';
  public static PermissionWalletLoad = 'wallet_load';
  public static PermissionCardUnload = 'card_unload';
  public static PermissionQueryActiveCard = 'query_active_card';
  public static PermissionQueryLoadStatus = 'query_load_status';
  public static PermissionSetupWebhook = 'setup_webhook';
  public static PermissionUpdatePartnerCustomerId = 'update_partner_customer_id';
  public static PermissionNoPayment = 'no_payment';

  comment: string;
  apiKeyType: PartnerApiKeyType;
  permissionPartnerPayment: boolean;
  permissionInvoicePayment: boolean;
  permissionCreditCardPayment: boolean;
  permissionSofortPayment: boolean;
  permissionNoPayment: boolean;

  permissionWalletBalance: boolean;
  permissionWalletLoad: boolean;
  permissionCardUnload: boolean;
  permissionQueryActiveCard: boolean;
  permissionQueryLoadStatus: boolean;
  permissionSetupWebhook: boolean;
  permissionUpdatePartnerCustomerId: boolean;

  title: string;
  text: string;
  apiKeyForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddApikeyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.title = 'Add API Key';
    this.text = 'Fill these options';

    if ( this.data ) {
      if (this.data.permissions) {
        const p = this.data?.permissions.split(',');
        p.forEach(element => {
          switch (element) {
            case AddApikeyDialogComponent.PermissionCreditCardPayment:
              this.permissionCreditCardPayment = true;
              break;
            case AddApikeyDialogComponent.PermissionPartnerPayment:
              this.permissionPartnerPayment = true;
              break;
            case AddApikeyDialogComponent.PermissionInvoicePayment:
              this.permissionInvoicePayment = true;
              break;
            case AddApikeyDialogComponent.PermissionSofortPayment:
              this.permissionSofortPayment = true;
              break;
            case AddApikeyDialogComponent.PermissionWalletBalance:
              this.permissionWalletBalance = true;
              break;
            case AddApikeyDialogComponent.PermissionWalletLoad:
              this.permissionWalletLoad = true;
              break;
            case AddApikeyDialogComponent.PermissionCardUnload:
              this.permissionCardUnload = true;
              break;
            case AddApikeyDialogComponent.PermissionQueryActiveCard:
              this.permissionQueryActiveCard = true;
              break;
            case AddApikeyDialogComponent.PermissionQueryLoadStatus:
              this.permissionQueryLoadStatus = true;
              break;
            case  AddApikeyDialogComponent.PermissionSetupWebhook:
              this.permissionSetupWebhook = true;
              break;
            case  AddApikeyDialogComponent.PermissionUpdatePartnerCustomerId:
              this.permissionUpdatePartnerCustomerId = true;
              break;
          }
        });
      }
      if ( this.data.comment ) {
        this.comment = this.data.comment;
      }

      this.apiKeyType = this.data.apiKeyType;
    }

    this.apiKeyForm = this.formBuilder.group({
      comment: this.comment || '',
      apiKeyType: this.apiKeyType,
      permissionPartnerPayment: this.permissionPartnerPayment,
      permissionInvoicePayment: this.permissionInvoicePayment,
      permissionSofortPayment: this.permissionSofortPayment,
      permissionCreditCardPayment: this.permissionCreditCardPayment,

      permissionWalletBalance: this.permissionWalletBalance,
      permissionWalletLoad: this.permissionWalletLoad,
      permissionCardUnload: this.permissionCardUnload,
      permissionQueryActiveCard: this.permissionQueryActiveCard,

      permissionQueryLoadStatus: this.permissionQueryLoadStatus,
      permissionSetupWebhook: this.permissionSetupWebhook,
      permissionUpdatePartnerCustomerId: this.permissionUpdatePartnerCustomerId,

    });
    this.apiKeyForm.markAsPristine();

  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    const ret = new PartnerApiKey();
    ret.comment = this.apiKeyForm.value.comment;
    ret.apiKeyType = this.apiKeyForm.value.apiKeyType;

    const permissions = [];
    if ( this.apiKeyForm.value.permissionSofortPayment ) {
      permissions.push(AddApikeyDialogComponent.PermissionSofortPayment);
    }
    if ( this.apiKeyForm.value.permissionCreditCardPayment ) {
      permissions.push(AddApikeyDialogComponent.PermissionCreditCardPayment);
    }
    if ( this.apiKeyForm.value.permissionInvoicePayment ) {
      permissions.push(AddApikeyDialogComponent.PermissionInvoicePayment);
    }
    if ( this.apiKeyForm.value.permissionNoPayment ) {
      permissions.push(AddApikeyDialogComponent.PermissionNoPayment);
    }
    if ( this.apiKeyForm.value.permissionPartnerPayment ) {
      permissions.push(AddApikeyDialogComponent.PermissionPartnerPayment);
    }
    if ( this.apiKeyForm.value.permissionWalletBalance ) {
      permissions.push(AddApikeyDialogComponent.PermissionWalletBalance);
    }
    if ( this.apiKeyForm.value.permissionWalletLoad ) {
      permissions.push(AddApikeyDialogComponent.PermissionWalletLoad);
    }
    if ( this.apiKeyForm.value.permissionCardUnload ) {
      permissions.push(AddApikeyDialogComponent.PermissionCardUnload);
    }
    if ( this.apiKeyForm.value.permissionQueryActiveCard ) {
      permissions.push(AddApikeyDialogComponent.PermissionQueryActiveCard);
    }
    if ( this.apiKeyForm.value.permissionQueryLoadStatus ) {
      permissions.push(AddApikeyDialogComponent.PermissionQueryLoadStatus);
    }
    if ( this.apiKeyForm.value.permissionSetupWebhook ) {
      permissions.push(AddApikeyDialogComponent.PermissionSetupWebhook);
    }
    if ( this.apiKeyForm.value.permissionUpdatePartnerCustomerId ) {
      permissions.push(AddApikeyDialogComponent.PermissionUpdatePartnerCustomerId);
    }


    ret.permissions = permissions.join(',');


    this.dialogRef.close(ret);

  }
}
